import { SanitizationGroup } from '../SanitizationGroup';

const BASE_TAGS_GROUP = [
    'a',
    'b',
    'i',
    'u',
    'em',
    'br',
    'span',
    'small',
    'strong'
];

const HTML_TAGS_GROUP = [
    ...BASE_TAGS_GROUP,
    'div',
    'p',
    'ol',
    'ul',
    'li'
];

/**
 * A mapping between sanitization group type and it's whitelisted tags.
 * @type {Object<String>}
 */
export const SANITIZATION_GROUP_TAGS_MAPPING = {
    [SanitizationGroup.BASE]: BASE_TAGS_GROUP,
    [SanitizationGroup.HTML]: HTML_TAGS_GROUP
};

/**
 * A list of HTML attributes that are potentially dangerous, and should be filtered.
 * @type {String[]}
 */
const BLACKLISTED_ATTRIBUTES = new Set();

[
    'onclick',
    'onload',
    'onblur',
    'onfocus',
    'onerror',
    'onkeydown',
    'onkeypress',
    'onkeyup',
    'onkeyup',
    'onmousedown',
    'onmouseenter',
    'onmouseleave',
    'onmousemove',
    'onmouseout',
    'onmouseover',
    'onmouseup'
].forEach((attr) => BLACKLISTED_ATTRIBUTES.add(attr));

export {
    BLACKLISTED_ATTRIBUTES
};
